import section from "../section/"

export default {
    "type": "array",
    "items": section
}